import React, { useContext } from "react";
import "./GlossaryPage_Coral";
import { BsSkipBackwardCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import DashboardMain_Coral from "../DashboardMain_Coral/DashboardMain_Coral";
import AppContext from "../../../store/AppContext";
import { useState } from "react";

function GlossaryPage_Erc_Coral() {
  const app_ctx = useContext(AppContext);
  return (
    <>
      <DashboardMain_Coral>
        <body style={{ backgroundColor: "white" }}>
          <h1
            style={{ fontWeight: "bold", marginTop: "6em", fontSize: "2em" }}
            align="center"
          >
            Glossary Page
            <Link
              to="/Driveanalysis_Coral"
              style={{ color: "#32879c", marginLeft: "5%", fontSize: "0.7em" }}
            >
              <BsSkipBackwardCircleFill />
            </Link>
          </h1>
          <table
            className="table table-hover tableglosary"
            style={{ width: "50%", height: "20%" }}
            align="center"
          >
            <thead style={{ backgroundColor: "#32879c", color: "#fff" }}>
              <tr>
                <td>Sr.No.</td>
                <td>KPI Name</td>
                <td>Business logics</td>
                <td>Backend Formula</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Total Vehicles</td>
                <td>Count of Vehicle Chassis for selected date range</td>
                <td>Count ( Distinct VIN )</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Total Km travelled</td>
                <td>Total Distance Covered for selected date range</td>
                <td>Sum (Median Delta ODO value of all vehicles)</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Median Range </td>
                <td>Median of Range in all discharge cycles of all vehicles</td>
                <td>
                  Median(Median Range in all discharge cycles of all vehicles)
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>Median Wh/km</td>
                <td>Median energy consumption per km of all discharge cycles</td>
                <td>
                  Median(Median Wh/km of all discharge cycles of all vehicles)
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>Median discharge duration </td>
                <td>Median of Discharge duration of all vehicles</td>
                <td>Median(Median discharge duration of all vehicles)</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Median Idle Percent</td>
                <td>Median idle percentage across all vehicles</td>
                <td>Median(Median Idle Time (%))</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Median Regen Percent</td>
                <td>Median regenerative braking percentage across all vehicles</td>
                <td>Median(Median regen percent)</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Median Eco Drive Percent</td>
                <td>Median eco drive mode percentage across all vehicles</td>
                <td>Median (Median Eco drive percent)</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Median Power Drive Percent</td>
                <td>Median power drive mode percentage across all vehicles</td>
                <td>Median (Median Power drive percent)</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Median BCS Active Time</td>
                <td>Median BCS active time percentage across all vehicles</td>
                <td>Median (Median BCS active time percent)</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Median BMS Max Cell Temperature</td>
                <td>Median maximum cell temperature recorded by BMS across all vehicles</td>
                <td>Median (Median BMS Max cell temperature)</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Median MCU Temperature</td>
                <td>Median motor control unit temperature across all vehicles</td>
                <td>Median (Median MCU temperature)</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Median DCDC Temperature 1</td>
                <td>Median DCDC temperature 1 across all vehicles</td>
                <td>Median (Median DCDC temperature 1)</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Median DCDC Temperature 2</td>
                <td>Median DCDC temperature 2 across all vehicles</td>
                <td>Median (Median DCDC temperature 2)</td>
              </tr>
            </tbody>
          </table>
        </body>
      </DashboardMain_Coral>
    </>
  );
}

export default GlossaryPage_Erc_Coral;
